import {ConversationType} from '../../../models/mongoose/MessageModel/enum/ConversationType'

export const THREAD_CONVERSATION_TYPES: ConversationType[] = [
  ConversationType.DatabaseCell,
  ConversationType.DatabaseFile,
  ConversationType.CloudFile,
]
